<template>
    <div class="warp">
        <!-- <div class="Chargingpile">
        <div class="mulberry">
          <div id="nulBerryDiagram">
            <Loading LoadingId="mulberryLoading" :scale="0.7" v-if="isRequest == true"/>
            <div style="height:100%; position: relative">
              <baidu-map class="map" :style="style" :center="center" :zoom="zoom" scroll-wheel-zoom @ready="handler">
                <bm-marker :position="center"></bm-marker>
              </baidu-map>
              <div class="mapBox_pile">
                <div v-for="item in pileList" :key="item.id" class="mapBox_pile_item">
                  <div>
                    <img :src="item.icon">
                  </div>
                  <div style="text-align: right">
                    <div class="mapBox_pile_item_counts" :style="'color: ' + item.color">{{ item.counts }}</div>
                    <div style="font-size: 15px">{{ item.name }}</div>
                  </div>
                </div>
                <div class="mapBox_pile_item" style="overflow: visible">
                  <Charts id="statusChart" :option="optionStatus" height="150px"></Charts>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
        <div class="Chargingpile">

            <div class="column-center wapp">
                <div class="site">
                    <span class="wiringItem active">储能集装箱</span>
                    <div class="boxSite">
                        <span v-for="(item, index) in 3" :key="index"></span>
                        <span>储能容量 200kW</span>
                        <span v-for="(item, index) in 3" :key="index"></span>
                    </div>
                </div>
            </div>
            <div class="group">
                <img src="../../assets/img/cnimg2.png" alt="" class="imgshow">
            </div>
        </div>
        <div class="energyxou">
            <DiaGram />
        </div>
    </div>
</template>
  
<script>
import Charts from '../../components/common/Charts.vue'
import Loading from '../../components/common/Loading.vue'
import DiaGram from './components/Diagram'

export default {
    components: {
        Charts, Loading, DiaGram
    },
    data() {
        return {
            style: {
                width: 100 + '%',
                height: 100 + '%',
            },
            center: { lng: 0, lat: 0 },
            zoom: 0,
            pileList: [
                {
                    id: Math.random() * +new Date(),
                    icon: pileSnowIcon,
                    counts: 9,
                    name: '交流电桩',
                    color: 'rgb(30, 145, 230)'
                }, {
                    id: Math.random() * +new Date(),
                    icon: pileQuickIcon,
                    counts: 0,
                    name: '直流电桩',
                    color: 'rgb(30, 145, 230)'
                }, {
                    id: Math.random() * +new Date(),
                    icon: pileIcon,
                    counts: 0,
                    name: '离线（枪）',
                    color: 'rgb(204, 204, 204)'
                }, {
                    id: Math.random() * +new Date(),
                    icon: pileIcon,
                    counts: 0,
                    name: '故障（枪）',
                    color: 'rgb(253, 52, 42)'
                },
            ],
            isRequest: true
        }
    },
    computed: {
        optionStatus() {
            return {
                color: '#0d94ff',
                title: {
                    subtext: '状态分析',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b} : ({d}%)'
                },
                legend: {
                    bottom: 10,
                    left: 'center',
                    data: ['CityA', 'CityB', 'CityD', 'CityC', 'CityE']
                },
                series: [
                    {
                        type: 'pie',
                        center: ['50%', '50%'],
                        selectedMode: 'single',
                        radius: ['40%', '70%'],
                        data: [{ value: 100, name: '正常' }],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            }
        }
    },
    created() {
        this.handleFn()
    },
    methods: {
        handler({ BMap, map }) {
            this.center.lng = 114.150354
            this.center.lat = 30.470982
            this.zoom = 17
        },
        handleFn() {
            setTimeout(() => {
                this.isRequest = false
            }, 2000)
        }
    }
};
</script>
  
<style scoped lang="less">
.site {
    width: 100%;
    height: 40rem;
    position: relative;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: row;

    .wiringItem,
    .wiringItem1 {
        width: 10%;
        height: 100%;
        background: #FFFFFF;
        border: 1px solid #0D94FF;
        border-radius: 4px;
        font-size: 14rem;
        font-weight: 500;
        color: #0E9CFF;
        display: inline-block;
        text-align: center;
        line-height: 40rem;
        padding: 0 5rem;
        cursor: pointer;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        z-index: 11;
    }

    .wiringItem:nth-child(4) {
        margin-left: 40%;
    }

    .active {
        background: #0E9CFF;
        color: #ffffff
    }

    .box {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: row;

        &>span {
            width: 10%;
            height: 100%;
            display: inline-block;
            background: #FFFFFF;
            border: 1px solid #0D94FF;
            border-radius: 4px;
            cursor: no-drop;
        }
    }

    .boxSite {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: row;

        &>span {
            width: 10%;
            height: 100%;
            display: inline-block;
            background: #FFFFFF;
            border: 1px solid #0D94FF;
            border-radius: 4px;
            cursor: no-drop;
        }

        &>span:nth-child(4) {
            width: 40%;
            background: #6DC8EC;
            border-radius: 4px;
            font-size: 16rem;
            font-family: Source Han Sans SC;
            font-weight: 800;
            color: #FFFFFF;
            line-height: 40rem;
            text-align: center;
            cursor: default;
        }
    }
}

.boxSite {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: row;

    &>span {
        width: 10%;
        height: 100%;
        display: inline-block;
        background: #FFFFFF;
        border: 1px solid #0D94FF;
        border-radius: 4px;
        cursor: no-drop;
    }

    &>span:nth-child(4) {
        width: 40%;
        background: #6DC8EC;
        border-radius: 4px;
        font-size: 16rem;
        font-family: Source Han Sans SC;
        font-weight: 800;
        color: #FFFFFF;
        line-height: 40rem;
        text-align: center;
        cursor: default;
    }
}


.Chargingpile {
    justify-content: space-between;
    background: #ffffff;

    .group {
        height: calc(100% - 40rem);
        position: relative;
    }

    .imgshow {
        width: 100%;
        height: 100%;
    }

    .zbsj {
        position: absolute;
        top: 0;
        left: 24px;
        height: 353px;
    }
}

.warp {
    height: 100%;
    width: 100%;
    background: none;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // background: #ffffff;

}

.Chargingpile {
    height: 59.5vh;
    display: flex;
    flex-direction: column;

    .mulberry {
        padding: 1vh 16rem;
        box-sizing: border-box;
        height: 100%;
        border-top: 1px solid rgba(0, 0, 0, 0.15);
        border-bottom: 1px solid rgba(0, 0, 0, 0.15);

        #nulBerryDiagram {
            height: 100%;
            position: relative;
            overflow: auto;

            &>img {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            .map {
                height: 100%;
            }

            .mapBox_pile {
                position: absolute;
                top: 30px;
                left: 15px;

                .mapBox_pile_item {
                    width: 150px;
                    background-color: #fff;
                    padding: 5px 10px;
                    margin-bottom: 5px;
                    border-radius: 8px;
                    display: flex;
                    justify-content: space-between;
                    overflow: hidden;

                    .mapBox_pile_item_counts {
                        font-size: 20px;
                        font-weight: 600;
                        font-family: "Microsoft YaHei";
                    }

                    #statusChart {
                        width: 100%;
                        height: 150px;
                    }
                }
            }
        }
    }

}

.energyxou {
    width: 62.1875vw;
    .h(320);
    // background-color: #fff;
    // padding: 0 16rem;
    position: relative;

    .title {
        height: 36rem;
        line-height: 36rem;
        font-size: 16rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
    }

    .tabType {
        height: 36rem;
        width: 100%;
        line-height: 36rem;
        font-size: 14rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        position: absolute;
        right: 22rem;
        z-index: 11;

        .typeItem {
            margin-left: 16rem;
            color: #333333;
            cursor: pointer;
        }

        .se {
            color: #0D94FF;
        }
    }

    .warp {
        height: 21vh;

        .nothing {
            position: absolute;
            top: 45%;
            left: 0%;
            right: 0%;
            margin: auto;
            width: 23%;
            height: 50%;
            background: url('../../assets/img/not_found_data.png') no-repeat;
            background-size: 100% 100%;
        }
    }
}</style>